(function(){
  var CUTOFF = 14;
  var WD = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];

  function easter(y){
    var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,
        f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,
        i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),
        mo=Math.floor((h+l-7*m+114)/31),da=((h+l-7*m+114)%31)+1;
    return new Date(y,mo-1,da);
  }
  function addDays(d,n){ var x=new Date(d); x.setDate(x.getDate()+n); return x; }
  function ymd(d){ return d.getFullYear()+'-'+(d.getMonth()+1)+'-'+d.getDate(); }

  function rlpHolidays(y){
    var e=easter(y), set={};
    [ [0,1],[5,1],[10,3],[11,1],[11,25],[11,26] ].forEach(function(m){ set[ymd(new Date(y,m[0],m[1]))]=1; });
    [ -2, 1, 39, 50, 60 ].forEach(function(off){ set[ymd(addDays(e,off))]=1; });
    return set;
  }
  function isHoliday(d){ return !!rlpHolidays(d.getFullYear())[ymd(d)]; }
  function isWorkday(d){ var w=d.getDay(); return w!==0 && w!==6 && !isHoliday(d); }
  function nextWorkday(d){ var x=addDays(d,1); while(!isWorkday(x)) x=addDays(x,1); return x; }

  function render(){
    var el=document.getElementById('versand-live'); if(!el) return;
    var t=document.getElementById('versand-live-text'); if(!t) t=el;
    var now=new Date(), txt='';
    if(isWorkday(now) && now.getHours()<CUTOFF){
      var end=new Date(now); end.setHours(CUTOFF,0,0,0);
      var diff=end-now, h=Math.floor(diff/3600000), m=Math.floor((diff%3600000)/60000);
      var rest = h>0 ? (h+' Std '+m+' Min') : (m+' Min');
      txt='Versand heute, wenn du in den nächsten '+rest+' bestellst';
    } else if(isWorkday(now)){
      txt='Versand morgen bis 14:00';
    } else {
      var nw=nextWorkday(now);
      var dd=('0'+nw.getDate()).slice(-2)+'.'+('0'+(nw.getMonth()+1)).slice(-2)+'.';
      txt='Versand am nächsten Werktag ('+WD[nw.getDay()]+', '+dd+')';
    }
    t.textContent=txt;
  }
  document.addEventListener('DOMContentLoaded',function(){ render(); setInterval(render,60000); });
})();
